import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

import { Row } from './Row'

export const RowButton = styled(Row).attrs({
	as: ButtonPlain,
})`
	position: relative;
	width: calc(100% + (${helpers.spacing.large} * 2));
	margin: 0 -${helpers.spacing.large};
	padding: ${helpers.spacing.small} ${helpers.spacing.large};

	&:hover:not(:disabled) {
		background-color: ${({ theme }) => transparentize(0.85, theme.color.actionHover)};
	}
`
